import { render } from "./BaseDialog.vue?vue&type=template&id=158ba6c8&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=158ba6c8&scoped=true&lang=css"

import exportComponent from "D:\\Shehab\\Coding\\vue\\Maxmillian\\Vue-The-Complete-Guide\\lec 18\\deploy01-starting-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158ba6c8"]])

export default __exports__